<template>
  <div class="popupItem" :class="{active: item.active}">
    <button type="button" class="btnDel" @click="delItem(item.id)"></button>
    <div class="dimm" @click="setActive(item.id)"></div>
    <div class="flexBox mb30">
      <div class="flexInner">
        <p class="setLabel mb5">{{ locale.name }}</p>
        <input type="text" class="input" v-model="item.name">
      </div>
      <div class="flexInner">
        <div class="mt15">
          <input type="checkbox" :id="`service_${item.id}`" v-model="item.service">
          <label class="btn" :class="{btnPrimary: item.service, btnLightGrey: !item.service}" :for="`service_${item.id}`">{{ locale.enabled }}</label>
        </div>
      </div>
    </div>
    <div class="flexBox">
      <div class="flexInner">
        <p class="setLabel mb5">URL</p>
        <!-- <button type="button" class="btn btnWhite" @click="setLink(item.url, 'url')">페이지 찾기</button>
        <div><input type="text" class="input" v-model="item.url.pageId" disabled></div> -->
        <div class="setLinkInner" :class="{isFold: isFold}">
          <SetLink
            :link="item.url"
            :fix="['page', 'product', 'shop', 'reservation', 'shortcut']" />
          <div class="btnFold" @click="isFold = !isFold"><button type="button">{{isFold ? '▼' : '▲'}}</button></div>
        </div>
      </div>
      <div class="flexInner">
        <p class="setLabel mb5">{{locale.page}}</p>
        <div class="mb10"><button class="btn btnWhite btnFull btnAdd" @click="addPopup">+</button></div>
        <div v-if="item.popup.length > 0" style="">
          <draggable
            :list="item.popup"
            :animation="200"
            handle=".handle">
            <div
              v-for="(page, index) in item.popup"
              :key="index"
              class="popupLink mb10"
              :class="{noPage: page.pageId_input_active ? !page.pageIdInput : !page.pageId}">
              <div class="input" @click="setLink(page, index)">{{ getPageName(page) }}</div>
              <button type="button" class="remove" @click="delPopup(index)"></button>
              <button type="button" class="handle"></button>
            </div>
          </draggable>
        </div>
      </div>
    </div>
    <div
      v-if="setLinkLayer"
      class="layer setLinkLayer">
      <div class="inner">
        <button type="button" class="btnClose" @click="setLinkApply(false)"><span class="blind">close</span></button>
        <SetLink
          :link="linkInfo"
          :fix="linkTypes"
          :pageIdInput="true" />
        <div class="btns">
          <button type="button" class="btn btnFull btnPrimary" @click="setLinkApply(true)">{{locale.apply}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink'
import draggable from 'vuedraggable'

export default {
  name: 'LayerpopupItem',
  props: [
    'locale',
    'item'
  ],
  components: {
    SetLink,
    draggable
  },
  computed: {
    pages () {
      return this.$store.getters['page/list']
    },
    linkTypes () {
      return this.linkInfoTarget === 'url' ? ['page', 'product', 'reservation', 'shortcut'] : ['page']
    }
  },
  mounted () {
  },
  data () {
    return {
      isFold: true,
      setLinkLayer: false,
      legacyLinkInfo: {},
      linkInfoTarget: '',
      linkInfo: {}
    }
  },
  methods: {
    getPageName (page) {
      const id = page.pageId
      const name = typeof (id) === 'undefined' || id === ''
        ? this.locale.link_page_placeholder
        : typeof (this.pages.find(x => x.pageData.id === id)) === 'undefined'
          ? this.locale.link_page_notexist
          : this.pages.find(x => x.pageData.id === id).pageData.title
      const pageIdInput = page.pageId_input_active && page.pageIdInput
      return pageIdInput || name
    },
    setLinkApply (isApply) {
      if (isApply) {
        const target = this.linkInfoTarget
        this.item.popup[target] = this.linkInfo
        this.setLinkLayer = false
      } else {
        if (window.confirm(this.locale.confirm_cancel)) {
          // item.link = this.legacyLinkInfo
          this.setLinkLayer = false
        }
      }
    },
    setLink (link, index) {
      this.setLinkLayer = true
      this.linkInfoTarget = index
      this.linkInfo = { ...link }
      this.legacyLinkInfo = this._.cloneDeep(link)
    },
    addPopup () {
      this.$emit('addPopup', this.item.id)
    },
    delPopup (index) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$emit('delPopup', { id: this.item.id, index: index })
      }
    },
    delItem (id) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$emit('delItem', id)
      }
    },
    setActive (id) {
      this.$emit('setActive', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.popupLink {
  position: relative;
  padding-right: 32px;
  color: $color-blue;
  .input {
    position: relative;
    padding-right: 40px;
    color: inherit;
    cursor: pointer;
  }
  &.noPage {
    color: $color-red;
  }
  .handle {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 100%;
    background: $color-lgrey2 url('~@/assets/img/ico_move.svg') 50% 50% / 20px no-repeat;
    cursor: move;
  }
  .remove {
    position: absolute;
    top: 0;
    right: 32px;
    width: 32px;
    height: 100%;
    background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
    opacity: 0.3;
  }
}
.setLinkLayer {
  .inner {
    max-width: 400px;
  }
  .btns {
    max-width: 180px;
    margin: 30px auto 0;
  }
}
.btnAdd {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 2em;
  line-height: 1;
}
</style>
